import React, { useId } from 'react';

import { LiveAssistCitation } from 'components/Alpha/LiveAssist/liveAssistContract';
import { useLiveAssistStyles } from 'components/Alpha/LiveAssist/liveAssistStyles';

interface Props {
  citations: LiveAssistCitation[];
}

const LiveAssistSources: React.FC<Props> = ({ citations }) => {
  const classes = useLiveAssistStyles();
  const labelId = `la-sources-${useId().replace(/:/g, '')}`;
  if (citations.length === 0) return null;
  return (
    <div className={classes.sources}>
      <span className={classes.sourcesLabel} id={labelId}>
        Sources
      </span>
      <ol className={classes.sourcesList} aria-labelledby={labelId}>
        {citations.map((citation, index) => (
          <li key={`${citation.title}-${index}`} className={classes.source}>
            {citation.url !== undefined ? (
              <a
                className={classes.sourceLink}
                href={citation.url}
                target="_blank"
                rel="noopener noreferrer"
              >
                {citation.title}
              </a>
            ) : (
              <span className={classes.source}>{citation.title}</span>
            )}
            {citation.source !== undefined && (
              <span className={classes.sourceOrigin}>{` · ${citation.source}`}</span>
            )}
          </li>
        ))}
      </ol>
    </div>
  );
};

export default LiveAssistSources;
